import { render, staticRenderFns } from "./GridProject.vue?vue&type=template&id=2bb42136&"
import script from "./GridProject.vue?vue&type=script&lang=js&"
export * from "./GridProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports